import Banner from "../../models/Banner";

export interface bannerStateInterface {
  banners: Banner[];
  lastCursor: string;
  loading: boolean;
}

const initState: bannerStateInterface = {
  banners: [],
  lastCursor: "",
  loading: false,
};

const bannersReducer: any = (state = initState, action: any) => {
  switch (action.type) {
    case "UPDATE_BANNER_LIST":
      return {
        ...state,
        banners: action.payload.banners,
        lastCursor: action.payload.lastCursor,
      };
    case "UPDATE_BANNER_LOADING":
      return {
        ...state,
        loading: action.payload.loading,
      };
    default:
      return state;
  }
};

export default bannersReducer;
